<template>
    <div class="item_content lg:flex items-center">
        <div class="label">
            {{ $t(value[0]) }}:
        </div>
        <div class="val">
            {{ meaning }}
        </div>
    </div>
</template>

<script>
export default {
    name: "DetailObjectType",
    props:{
        value:{
            type:Array,
        },
    },
    computed:{
        meaning(){
            if(Array.isArray(this.value[1])){
                let name = ''
                this.value[1].forEach((item)=>{
                    name += item.name + ' '
                })
                return name
            }else if(typeof this.value[1] === 'object'){
                return this.define_type(this.value[1].name)
            }else{
                return this.define_type(this.value[1])
            }
        }
    },
    methods:{
        define_type(value){
            if (typeof value === 'boolean'){
                return value?this.$t('Yes'):this.$t('No')
            }else{
                return value
            }
        }
    }

};
</script>

<style scoped>
.label{
    font-weight: bold;
    padding-right: 10px;
    min-width: 280px;
}
</style>
